export const CREATE_TIMESHEET_ROW_REQUEST = 'CREATE_TIMESHEET_ROW_REQUEST';
export const CREATE_TIMESHEET_ROW_REQUEST_FAILURE = 'CREATE_TIMESHEET_ROW_REQUEST_FAILURE';
export const CREATE_TIMESHEET_ROW_REQUEST_SUCCESS = 'CREATE_TIMESHEET_ROW_REQUEST_SUCCESS';

export const DELETE_TIMESHEET_ROW_REQUEST = 'DELETE_TIMESHEET_ROW_REQUEST';
export const DELETE_TIMESHEET_ROW_REQUEST_FAILURE = 'DELETE_TIMESHEET_ROW_REQUEST_FAILURE';
export const DELETE_TIMESHEET_ROW_REQUEST_SUCCESS = 'DELETE_TIMESHEET_ROW_REQUEST_SUCCESS';

export const GET_TIMESHEET_ROW_REQUEST = 'GET_TIMESHEET_ROW_REQUEST';
export const GET_TIMESHEET_ROW_REQUEST_FAILURE = 'GET_TIMESHEET_ROW_REQUEST_FAILURE';
export const GET_TIMESHEET_ROW_REQUEST_SUCCESS = 'GET_TIMESHEET_ROW_REQUEST_SUCCESS';

export const GET_TIMESHEET_ROWS_REQUEST = 'GET_TIMESHEET_ROWS_REQUEST';
export const GET_TIMESHEET_ROWS_REQUEST_FAILURE = 'GET_TIMESHEET_ROWS_REQUEST_FAILURE';
export const GET_TIMESHEET_ROWS_REQUEST_SUCCESS = 'GET_TIMESHEET_ROWS_REQUEST_SUCCESS';

export const RESET_TIMESHEET_ROWS_STATE = 'RESET_TIMESHEET_ROWS_STATE';
